import BaseService from './baseService';
import { CreateRunConfigPayload, RunConfigForEdit } from 'store/resourceAdequacy/types';

export default class ResourceAdequacyService extends BaseService {
    constructor() {
        super('resourceAdequacy');
    }

    /**
    * Gets Run configs
    * @param {number} taskId 
    * @returns list of Run configs
    */
    getRunConfigs = (taskId: number) => this.httpGetRequest(`getRunConfigsViewModel/${taskId}`);

    /**
    * Gets Run config
    * @param {number} runConfigId 
    * @returns Run configs item
    */
    getRunConfig = (runConfigId: number) => this.httpGetRequest(`getRunConfigEditItem/${runConfigId}`);

    /**
    * Gets Run config
    * @param {number} runConfigId 
    * @returns Run configs item
    */
    getRunConfigForCopy = (runConfigId: number) => this.httpGetRequest((`getRunRequest/${runConfigId}`))

    /**
    * Creates Run Config as SNAP
    * @param {Object<CreateRunConfigPayload>} runConfig
    * @returns void
    */
    createFullRunConfig = (runConfig: CreateRunConfigPayload) => this.httpPostRequest('createRunConfig', runConfig);

    /**
    * Creates Run Config as Standart
    * @param {Object<CreateRunConfigPayload>} runConfig
    * @returns void
    */
    createRunConfig2Stage = (runConfig: CreateRunConfigPayload) => this.httpPostRequest('createRunConfigIntermediateResultsStageOnly', runConfig);

    /**
    * Updates Run Config
    * @param {Object<RunConfigForEdit>} runConfig
    * @returns Updated Run Config Item
    */
    editRunConfig = (runConfig: RunConfigForEdit) => this.httpPatchRequest('updateRunConfig', runConfig);

    /**
    * Sarts running filtering stage
    * @param {number} runConfigId
    * @returns void
    */
    runFilteringStage = (runConfigId: number) => this.httpPostRequest(`enqueueFilteringStage/${runConfigId}`);

    /**
    * Sarts running 2 stage after filtering
    * @param {number} runConfigId
    * @returns void
    */
    run2StageAfterFiltering = (runConfigId: number) => this.httpPostRequest(`enqueueIntermediateResultsStage`, [runConfigId]);

    /**
    * Sarts running 2 stage only. Used for RAmode Standart.
    * @param {number} runConfigId
    * @returns void
    */
    run2StageOnly = (runConfigId: number) => this.httpPostRequest(`enqueueIntermediateResultsStageOnly/${runConfigId}`);

    /**
    * Stopes running Run config
    * @param {number} runConfigId 
    * @returns void
    */
    stopConfig = (runConfigId: number) => this.httpPostRequest(`stopResourceAdequacyRun/${runConfigId}`);

    /**
    * Deletes Run config
    * @param {number} runConfigId 
    * @returns void
    */
    deleteRunConfig = (runConfigId: number) => this.httpDeleteRequest(`deleteRunConfig/${runConfigId}`);
}
